<template>
	<div class="markdown">
		<div class="md" v-html="output"></div>
	</div>
</template>

<script setup>
	import markdownIt from "markdown-it"
	import { ref } from "vue"

	const output = ref(null)
	const props = defineProps({ source: String })

	// onMounted(() => {
	const md = new markdownIt()
	const rendered = md.render(
		props.source.replace(/\\\\n|\\n/g, "\n")
		// .replace(/\s{2,}/g, "")
	)
	output.value = rendered
	// console.log(output)
	// })
</script>

<style lang="less">
	.markdown {
		.md {
			* {
				color: #ff6400 !important;
			}
		}
	}
</style>
